import axiosInstance from '../components/utils/axios/axiosInstance';
// eslint-disable-next-line import/named
import {
  MAIN_PAGE,
  SUCCESS_PAGE,
  SET_RESERVATION_ID
} from './constantsActions';

export const reportSuccess = () => {
  return {
    type: 'REPORT_SUCCESS'
  };
};

export const sendReport = (formData, msg, Id, carPlate) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .post('/api/report/addReport', formData, {
        params: {
          message: msg,
          reservationId: Id,
          status: 'NEW',
          carPlateNo: carPlate
        }
      })
      .then(() => {
        dispatch(reportSuccess());
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
};

export const changeStep = (stepNumber) => (dispatch) => {
  if (stepNumber === 1) {
    dispatch({
      type: MAIN_PAGE
    });
  } else {
    dispatch({
      type: SUCCESS_PAGE
    });
  }
};

export const setReservationId = (reservationId) => (dispatch) => {
  dispatch({
    type: SET_RESERVATION_ID,
    id: reservationId
  });
};
